import { ECOM_APP_DEF_ID } from './ecom';
export const navigateToCheckout = ({ wixCodeApi })=>async (checkoutId)=>{
        const ecomPublicApi = await wixCodeApi.site.getPublicAPI(ECOM_APP_DEF_ID);
        await ecomPublicApi.navigate.toCheckout({
            checkoutId,
            disableContinueShopping: true
        });
    };

//# sourceMappingURL=navigate-to-checkout.js.map